interface CustomPiePoint extends Highcharts.Point {
  name: string
  y: number
  percentage: number
}

export const getConversationStatsChartOptions = (
  chartData: [string, number][],
  totalChats: number
): Highcharts.Options => {
  return {
    chart: {
      type: "pie",
      height: 225,
      backgroundColor: "transparent"
    },
    title: {
      text: `<div style="text-align: center; display: flex; flex-direction: column; align-items: center; justify-content: center; position: relative;top:12px">
        <div style="font-family: Inter, sans-serif; font-size: 18px; font-weight: 800; line-height: 24px; color: #232227; white-space: nowrap;">${totalChats.toLocaleString()}</div>
        <div style="font-family: Roboto, sans-serif; font-size: 12px; font-weight: 400; line-height: 20px; letter-spacing: 0.48px; color: #232227; text-transform: uppercase; white-space: nowrap; margin-top: 2px;">TOTAL CHATS</div>
      </div>`,
      align: "center",
      verticalAlign: "middle",
      useHTML: true,
      y: 0
    },
    credits: {
      enabled: false
    },
    colors: ["#4c67ff", "#b3e6e5", "#7a6fff", "#63C7C4"],
    plotOptions: {
      pie: {
        allowPointSelect: false,
        cursor: "default",
        dataLabels: {
          enabled: true,
          distance: 15,
          connectorWidth: 1,
          connectorColor: "#232227",
          connectorShape: "crookedLine",
          crookDistance: 1,
          useHTML: true,
          connectorPadding: 0,
          style: {
            whiteSpace: "nowrap",
            textOverflow: "none"
          },
          overflow: "justify", // forces reposition instead of clipping
          crop: false,
          formatter: function () {
            const point = this.point as unknown as CustomPiePoint
            const percentage = point.percentage.toFixed(1)
            const value = Math.round(point.y).toLocaleString()
            const name = point.name || ""
            const isLeftSide =
              ((point as any)?.dataLabel?.x ?? 0) <
              point.series.chart.plotWidth / 2

            return `<div style="text-align: ${
              isLeftSide ? "right" : "left"
            }; font-family: Roboto, sans-serif;">
              <div style="font-weight: 600; font-size: 11px; white-space: pre-wrap;min-width: 80px;">${name}</div>
              <div style="font-weight: 400; font-size: 11px; padding-top: 4px">${value} (${percentage}%)</div>
            </div>`
          }
        },
        showInLegend: false,
        slicedOffset: 0,
        innerSize: "60%",
        size: "75%",
        borderWidth: 3,
        borderColor: "#ffffff",
        states: {
          hover: {
            enabled: false
          },
          inactive: {
            enabled: false
          }
        }
      }
    },
    series: [
      {
        type: "pie",
        name: "Conversations",
        keys: ["name", "y"],
        data: chartData,
        states: {
          hover: {
            enabled: false
          },
          inactive: {
            opacity: 1
          }
        }
      }
    ],
    legend: {
      enabled: false
    },
    tooltip: {
      enabled: false
    }
  }
}
